// extracted by mini-css-extract-plugin
export default {"container":"orders-tape_container__3hblC","orderListWrapper":"orders-tape_orderListWrapper__UtCS5","link":"orders-tape_link__oJqyr"};